/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-20
 * @brief EHP 메뉴 관리 개발
 *
 ********************************************************************/
import React, { useState } from "react";
import clog from "../../../utils/logUtils";
//component
import MenuTree from "./MenuTree";
import AuthCRUD from "./auth/AuthCRUD";
import LangCRUD from "./lang/LangCRUD";
/**
 * @brief EHP 메뉴 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function MenuMain(props) {
    //
    const [isMobile, setIsMobile] = useState(false);
    const [adminType, setAdminType] = useState("AUTH"); // AUTH, LANG
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH, SET
    const [workMode, setWorkMode] = useState("READ");
    const defaultTree = {
        menu: { menuId: "", menuName: "" },
        reload: false
    };
    const [selTree, setSelTree] = useState(defaultTree);
    function handleSelTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setAdminType(adminType);
        setSelTree(treeInfo);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuTree, { selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, adminType: adminType, setAdminType: setAdminType }),
        (adminType === "AUTH") && React.createElement(AuthCRUD, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin }),
        (adminType === "LANG") && React.createElement(LangCRUD, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin })));
}
export default MenuMain;
